module.exports = __webpack_public_path__ + "static/img/icon-club-carl.039f548.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-club-carl.svg
// module id = 0Rd1
// module chunks = 0